import flatpickr from "flatpickr";
import 'flatpickr/dist/l10n/gr.js';
import dayjs from "dayjs";

document.addEventListener("DOMContentLoaded", () => {
    const button = document.getElementById("datePickerInput");
    if (!button)
        return;

    let maxDate;
    let refDate;

    if (button) {
        maxDate = button.attributes['data-max-date'].value;
        refDate = button.attributes['data-ref-date'].value;
    } else {
        maxDate = dayjs().format('YYYY-MM-DD');
        refDate = dayjs().format('YYYY-MM-DD');
    }

    const newspaperId = button.attributes['data-newspaper-id']?.value ?? "";
    const _refDate = dayjs(refDate);
    const _maxDate = dayjs(maxDate);
    const isMobileApp = button.getAttribute('data-ismobileapp') == "1"

    flatpickr("#datePickerInput", {
        dateFormat: 'Y-m-d',
        disableMobile: true,
        maxDate: _maxDate.toDate(),
        defaultDate: _refDate.toDate(),
        locale: 'gr',
        onValueUpdate: (_selectedDates, dateStr) => {
            const _appendUrl = isMobileApp ? "?nb_mobile_app=1" : '';
            location.href = `/newspapers/${dateStr}${newspaperId ? `/${newspaperId}` : ""}${_appendUrl}`
        }
    });
});